
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
import demo from './demo/demo.twig';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Objects/Button Group" args={{
      grow: false,
      count: 2
    }} argTypes={{
      grow: {
        type: {
          name: 'boolean'
        },
        description: 'Controls the button full width modifier'
      },
      count: {
        type: {
          name: 'number'
        },
        description: 'Number of buttons to render',
        control: {
          type: 'range',
          min: 1,
          max: 10,
          step: 1
        }
      }
    }} mdxType="Meta" />
    <h1>{`Button Group`}</h1>
    <p>{`The Button Group layout object can be used for aligning a group of related buttons.`}</p>
    <h2>{`Default`}</h2>
    {
      /* The object demo is not particularly helpful if its source is imported directly,
      so we've provided it manually to the docs add-on via parameters. */
    }
    <Canvas mdxType="Canvas">
  <Story name="Default" parameters={{
        docs: {
          source: {
            code: `{% embed '@cloudfour/objects/button-group/button-group.twig' only %}
  {% block content %}
    {% include '@cloudfour/components/button/button.twig' with {
      label: 'Button 1'
    } only %}
    {% include '@cloudfour/components/button/button.twig' with {
      label: 'Button 2'
    } only %}
  {% endblock %}
{% endembed %}`
          }
        }
      }} mdxType="Story">
    {args => demo(args)}
  </Story>
    </Canvas>
    <h2>{`Grow modifer`}</h2>
    <p>{`You can have the buttons grow to fill their horizontal space via
the template `}<inlineCode parentName="p">{`grow`}</inlineCode>{` boolean argument:`}</p>
    {
      /* The object demo is not particularly helpful if its source is imported directly,
      so we've provided it manually to the docs add-on via parameters. */
    }
    <Canvas mdxType="Canvas">
  <Story name="Grow" args={{
        count: 5,
        grow: true
      }} parameters={{
        docs: {
          source: {
            code: `{% embed '@cloudfour/objects/button-group/button-group.twig' with {
  grow: true
} only %}
  {# buttons #}
{% endembed %}`
          }
        }
      }} mdxType="Story">
    {args => demo(args)}
  </Story>
    </Canvas>
    <h2>{`Template Properties`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`class`}</inlineCode>{`: Append a class to the root element.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`content`}</inlineCode>{` (block): Block to add Button elements.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`grow`}</inlineCode>{` (boolean, default: `}<inlineCode parentName="li">{`false`}</inlineCode>{`): Adds the `}<inlineCode parentName="li">{`o-button-group--grow`}</inlineCode>{` CSS class modifier.`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;

export const defaultStory = (args => demo(args));
defaultStory.storyName = 'Default';
defaultStory.parameters = { storySource: { source: 'args => demo(args)' }, ...{
  docs: {
    source: {
      code: `{% embed '@cloudfour/objects/button-group/button-group.twig' only %}
  {% block content %}
    {% include '@cloudfour/components/button/button.twig' with {
      label: 'Button 1'
    } only %}
    {% include '@cloudfour/components/button/button.twig' with {
      label: 'Button 2'
    } only %}
  {% endblock %}
{% endembed %}`
    }
  }
} };

export const grow = (args => demo(args));
grow.storyName = 'Grow';
grow.args = {
  count: 5,
  grow: true
};
grow.parameters = { storySource: { source: 'args => demo(args)' }, ...{
  docs: {
    source: {
      code: `{% embed '@cloudfour/objects/button-group/button-group.twig' with {
  grow: true
} only %}
  {# buttons #}
{% endembed %}`
    }
  }
} };

const componentMeta = { title: 'Objects/Button Group', args: {
  grow: false,
  count: 2
}, argTypes: {
  grow: {
    type: {
      name: 'boolean'
    },
    description: 'Controls the button full width modifier'
  },
  count: {
    type: {
      name: 'number'
    },
    description: 'Number of buttons to render',
    control: {
      type: 'range',
      min: 1,
      max: 10,
      step: 1
    }
  }
}, includeStories: ["defaultStory","grow"],  };

const mdxStoryNameToKey = {"Default":"defaultStory","Grow":"grow"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;